import { Megaphone } from 'lucide-react';
import type { LucideLikeIcon } from '@givmo/design-system';
import type { ModuleNav } from '@givmo/org-console';
import type { FundraisersFlavor } from './fundraisers-config';
import { FUNDRAISERS_SLUG } from './fundraisers-routes';

/**
 * The module's ONE root row id — the row another module's nav BORROWS by reference (the Donations
 * "Fundraisers" row, D-CPO-40 (3); Org Machinery OM-18). A host names it through this constant,
 * never a literal, so a renamed row is a compile error before it is a host-rail failure.
 */
export const FUNDRAISERS_ROOT_ROW = FUNDRAISERS_SLUG;

/**
 * The module's nav: one root row on the host flavor's READ string — the string the portfolio's read
 * requires, and so what admits a person to the page a borrowing frame opens. Writes gate in-page on
 * the flavor's write string (`mayWriteFundraisers`), never on the row. The shell supplies Team.
 */
export function fundraisersNav(
  flavor: Pick<FundraisersFlavor, 'readPermission'>,
): ModuleNav<LucideLikeIcon> {
  return {
    slug: FUNDRAISERS_SLUG,
    sections: [
      {
        id: FUNDRAISERS_SLUG,
        label: 'Fundraisers',
        rows: [
          {
            id: FUNDRAISERS_ROOT_ROW,
            label: 'Fundraisers',
            icon: Megaphone,
            destination: { kind: 'module', slug: FUNDRAISERS_SLUG },
            requires: flavor.readPermission,
          },
        ],
      },
    ],
    includeOrganizationSection: true,
  };
}
